import React from 'react'

import Service from  '../home/Service'

const ServicePage = () => {
  return (
    <>
    
    <Service/>


    </>
  )
}

export default ServicePage